<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="Loaderstatus"
		>
			<Spinner />
		</div>
		<div :class="{ 'form-disabled': isUploadLocked }">
			<div class="secsub-left-quescontainer">
				<div class="sec-addquescontainer">
					<div class="d-flex">
						<div style="width: 40%" class="sec-addques-headtxt">
							Descriptive
						</div>
						<div
							style="width: 20%"
							class="topDiv relativeclass ckeditor ques-tag-form-control w-40"
						>
							<b-form-tags
								v-model="questions.questionTags"
								no-outer-focus
								separator=" "
								remove-on-delete
								ref="questionTagref"
							>
								<template
									v-slot="{
										tags,
										inputAttrs,
										inputHandlers,
										tagVariant,

										removeTag,
									}"
								>
									<b-input-group class="cust-group-input" id="addcontainer-tag">
										<div class="d-flex no-wrap">
											<div
												class="d-inline-block cust-btn-select"
												style="font-size: 1.5rem"
											>
												<b-form-tag
													v-for="tag in tags"
													@remove="removeTag(tag)"
													:key="tag"
													:title="tag"
													:variant="tagVariant"
													class="mr-1 ml-2"
													>{{ tag }}</b-form-tag
												>
											</div>
											<b-form-input
												id="input-tag"
												v-bind="inputAttrs"
												v-on="inputHandlers"
												@keyup="hashtag()"
												placeholder="Enter Question tag"
												class="form-control min-width mr-4 ml-2"
											></b-form-input>
										</div>
									</b-input-group>
								</template>
							</b-form-tags>
						</div>
						<div class="relativeclass ml-2" ref="showdiffoptions">
							<div
								v-if="showdiffoptions"
								class="diff-dropdown d-flex"
								ref="showdiff"
								v-closable="{
									exclude: ['showdiffoptions', 'showdiff'],
									handler: 'hidediffoptions',
								}"
							>
								<b-form-group class="sec-mcq-datacard">
									<b-form-radio-group
										class="text-align-center"
										id="btn-radios-3"
										:options="options"
										value-field="value"
										text-field="text"
										name="radio-btn-stacked"
										@change="showdiffoptions = !showdiffoptions"
										buttons
										stacked
										v-model.trim="$v.questions.difficultyLevel.$model"
									></b-form-radio-group>
								</b-form-group>
							</div>
							<div
								class="sec-addquesbox-rightside"
								@click="showdiffoptions = !showdiffoptions"
							>
								<b-form-input
									style="background: transparent"
									class="pointer"
									readonly
									:class="{
										error: $v.questions.difficultyLevel.$error,
									}"
								>
								</b-form-input>
								<div class="placeholder">
									Difficulty Level {{ questions.difficultyLevel
									}}<span v-if="questions.difficultyLevel == ''">*</span>
								</div>
								<div
									style="position: absolute; top: 5px; right: 2vw"
									v-if="
										$v.questions.difficultyLevel.$dirty &&
											!$v.questions.difficultyLevel.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div class="diff-downarrow">
									<img
										v-if="!showdiffoptions"
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-2 pointer"
									/>
									<img
										v-else
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-2 pointer"
									/>
								</div>
							</div>
						</div>
						<div style="width: 20%" class="relativeclass ml-2">
							<b-form-input
								v-model.trim="$v.questions.marks.$model"
								:class="{
									error: $v.questions.marks.$error,
								}"
								@keypress="validateMarks($event)"
							>
							</b-form-input>
							<div
								class="placeholder"
								v-if="questions.marks == null || !$v.questions.marks.required"
							>
								Marks <span>*</span>
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="$v.questions.marks.$dirty && !$v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									!$v.questions.marks.between && $v.questions.marks.required
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should be between (0.5, 100)',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="!$v.questions.marks.alpha && $v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Accepts only 2 digit after decimal point',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>

					<div class="mt-2">
						<div class="topDiv mt-3 relativeclass">
							<div
								:class="
									dirtyLongQuestion ||
									(!$v.questions.question.maxLength && !dirtyLongQuestion)
										? 'error'
										: ''
								"
							>
								<label class="addquesboxfieldsetStyle" style="z-index: 4">
									Question &nbsp;<span class="asterik">*</span></label
								>
								<QuillEditor
									:addquesProp="addques"
									:value="$v.questions.question.$model"
									@validationVal="validateText"
									@questionText="updateQuestionContent"
									@addquesBack="changedaddQues"
								>
								</QuillEditor>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="dirtyLongQuestion && $v.questions.question.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Required',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="!$v.questions.question.maxLength && !dirtyLongQuestion"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 10000 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
							<div class="media-box mt-2 align-items-center">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center">
										<div class="media-text ml-3">Add Media</div>
										<div class="ml-2">
											<img src="../../assets/vertical-line.svg" alt="" />
										</div>
										<div
											class="d-flex align-items-center ml-2 mt-1"
											v-b-tooltip.hover="{ variant: 'secondary' }"
											title="Audio supported formats are: wav, mp3"
										>
											<div class="ml-2">
												<label for="file-upload" class="pointer">
													<img src="../../assets/headphone.svg" alt="" />
												</label>
												<input
													id="file-upload"
													type="file"
													accept="audio/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Video supported formats is: mp4"
											>
												<label for="file-upload-video" class="pointer">
													<img src="../../assets/videocam.svg" alt="" />
												</label>
												<input
													id="file-upload-video"
													type="file"
													accept="video/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Image supported formats are: jpg, jpeg, png"
											>
												<label for="file-upload-image" class="pointer">
													<img src="../../assets/image-capture.svg" alt="" />
												</label>
												<input
													id="file-upload-image"
													type="file"
													accept="image/*"
													@change="previewFile"
												/>
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center"
										v-if="questions.isFailed"
									>
										<img src="../../assets/Vector.svg" alt="" class="mr-2" />
										<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
									</div>
								</div>
							</div>
							<div
								style="position: absolute; top: 10px; right: 20px"
								v-if="dirtyLongQuestion && !$v.questions.question.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
						<!-- below div comes if image exists -->
						<template v-if="checkMedia">
							<div
								v-if="isImage(questions.questionMediaType)"
								class="mt-2 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<div class="dbmcqcardimage">
										<img
											:src="questions.questionMedia"
											alt=""
											class="w-100 h-100"
										/>
									</div>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>

							<!-- below div comes if audio exists -->
							<div
								v-if="isAudio(questions.questionMediaType)"
								class="d-flex mt-2"
							>
								<div class="d-flex align-items-center mr-5">
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2"> Audio</span>
								</div>
								<div class="d-flex align-items-center relativeclass">
									<Media
										:kind="'audio'"
										:isMuted="false"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio"
										:src="questions.questionMedia"
									></Media>
									<div class="mcq-audioxmark pointer" @click="removeMedia()">
										<img src="../../assets/xmark.svg" alt="" />
									</div>
								</div>
							</div>
							<div
								v-if="isVideo(questions.questionMediaType)"
								class="mt-3 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="questions.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="dbmcqcardimage"
									></Media>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</template>
					</div>
					<b-row v-if="showVideoUploading">
						<b-col class="ab-uploaded-card w-100 mt-3">
							<b-card no-body class="d-flex w-100">
								<section class="d-flex align-items-center pt-1">
									<div
										class="ab-uploaded-file-heading d-flex align-items-center w-75"
									>
										{{ videoData.name }}
									</div>

									<div
										class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
									>
										<b-spinner v-if="showSpinner" label="Spinning"></b-spinner>
										<span>{{ formatSize(videoData.size) }}</span>
										<!-- <span class="ml-2"> 2 sec Left</span> -->
									</div>
									<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
								</section>
								<section class="mt-2">
									<b-progress height="4px" :value="progress"></b-progress>
								</section>
							</b-card>
						</b-col>
					</b-row>
					<div class="topDiv mt-3">
						<label class="addquesboxfieldsetStyle"> Answer &nbsp;</label>
						<b-form-textarea
							placeholder="Enter something..."
							rows="3"
							max-rows="6"
							v-model="$v.questions.correctAnswer.$model"
							:class="{
								error: $v.questions.correctAnswer.$error,
							}"
						></b-form-textarea>
						<div
							style="position: absolute; top: 12px; right: 10px"
							v-if="
								!$v.questions.correctAnswer.maxLength &&
									!$v.questions.correctAnswer.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 1024 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</div>

				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-between p-1"
				>
					<div class="d-flex align-items-center">
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="questions.required"
						>
							Mandatory question
						</b-form-checkbox>
					</div>
					<div class="d-flex pointer relativeclass">
						<div class="sec-addcheckboxtext mr-3" ref="showdatacard1">
							<span
								@click="
									type == 'autolong' ? addautomcqquestion() : addquestion()
								"
								>Add</span
							>
						</div>
						<div @click="clearData()" class="sec-canceltext-active">Cancel</div>
						<div
							v-if="showdatacard"
							ref="showdatacard"
							v-closable="{
								exclude: ['showdatacard', 'showdatacard1'],
								handler: 'hidedatacard',
							}"
						>
							<div class="sec-adddata-card d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToDatabank"
										name="flavour-4a"
									>
										Add to Questionbank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToPublic"
										name="flavour-4a"
									>
										Add to public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="attachdocs"
			v-model="uploadModal"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div class="d-flex flex-column align-items-center">
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
										Click to browse or drag <br />and drop your files
									</div>
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
							<div v-if="questions.isFailed == true">
								<p style="color: red">Uploaded failed</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import QuillEditor from "./quillEditor.vue"; //Quill editor from component

import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

import {
	required,
	maxLength,
	between,
	helpers,
} from "vuelidate/lib/validators";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

import { mapGetters } from "vuex";
import toast from "../../views/mixin/toast";
import { postCommonQuestionv2 } from "../../utils/apiFunctions";
import mediaUploadMixin from "@/views/mixin/mediaUploadMixin";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";

export default {
	name: "LongForm",
	mixins: [toast, mediaUploadMixin, socketUploadMixin],
	components: {
		Media,
		QuillEditor, //From quill component
		Spinner,
	},
	props: {
		type: String,
		autosectionID: String,
		questions: Object,
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
			questionAdded: "getQuestionAdded",
		}),
		...mapGetters("autotestVUEX", {
			autoselectedSection: "getSelectedSection",
			topicID: "getAutoTopicID",
		}),
	},
	watch: {
		selectedSection(newValue, oldValue) {
			if (newValue != oldValue) {
				this.questions.questionMediaType = "";
				this.questions.questionMedia = "";
			}
		},
	},
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			addques: false,
			Loaderstatus: false,
			dirtyLongQuestion: false,
			checkMedia: false,
			uploadModal: false,
			showdiffoptions: false,
			showdatacard: false,
			options: [
				{ value: "1", text: "Difficulty Level 1" },
				{ value: "2", text: "Difficulty Level 2" },
				{ value: "3", text: "Difficulty Level 3" },
				{ value: "4", text: "Difficulty Level 4" },
				{ value: "5", text: "Difficulty Level 5" },
			],

			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-","insertTable"],
			},
		};
	},
	validations: {
		questions: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			correctAnswer: {
				maxLength: maxLength(1024),
			},
		},
	},
	created() {
		if (this.questions.file && this.questions.questionMedia) {
			this.checkMedia = true;
		}
	},
	methods: {
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyLongQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.questions.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},

		//For removing Space From Top and bottom of last text of Quill Editor
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.questions.question;
			const pTags = tempDiv.querySelectorAll("p");
			let endIndex = pTags.length;
			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.questions.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		isImage,
		isVideo,
		isAudio,
		hidedatacard() {
			this.showdatacard = false;
		},
		hidediffoptions() {
			this.showdatacard = false;
			this.showdiffoptions = false;
		},
		async previewFile(event) {
			const file = event.target.files[0];
			if (!file) return;
			this.videoData = {
				name: file.name,
				size: file.size,
			};
			await this.handleMediaUpload(event, this.questions);
			this.questions.file = this.questions.questionFile;
			this.checkMedia = !this.questions.isFailed;
		},

		resetModal() {
			this.questions.isFailed = false;
		},
		hashtag() {
			let str = document.getElementById("input-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag").value = tagged;
		},

		async addquestion() {
			if (this.questions.file) {
				this.showVideoUploading = true;
			}

			this.showSpinner = true;
			const questiontags = this.questions.questionTags.map((s) =>
				s[0] === "#" ? s.slice(1) : s
			);

			this.validateQuestionmcq();

			if (this.$v.$invalid || this.dirtyLongQuestion) {
				this.errorToast("Please enter all the details");
				return;
			}

			try {
				let bucketPath = null;

				// SOCKET UPLOAD (missing till now)
				if (this.questions.file && this.questions.fileMeta) {
					bucketPath = await this.uploadFileViaSocket(
						this.questions.file,
						this.questions.fileMeta
					);
				}

				// pass bucketPath
				const form = this.createFormData(questiontags, bucketPath);

				const res = await this.postFormDatamcq(form);

				if (res.status === 200) {
					this.successToast("Question added successfully!");
					this.$emit("question-added");
					this.clearData();
					this.dirtyLongQuestion = false;
					this.showVideoUploading = false;
					this.showSpinner = false;
					this.progress = 0;
					this.videoData = {};
				}
			} catch (err) {
				this.errorToast(err?.message || "Something went wrong");
			}
		},
		validateQuestionmcq() {
			if (this.questions.question == "") {
				this.dirtyLongQuestion = true;
			}
			this.$v.$touch();
		},

		createFormData(questiontags, bucketPath = null) {
			const form = new FormData();

			for (const key in this.questions) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key == "questionMedia") {
					if (bucketPath) {
						form.append("questionMediaPath", bucketPath);
						form.append("questionMediaType", this.questions.questionMediaType);
					} else if (
						!this.questions.file &&
						this.questions.questionMedia !== ""
					) {
						continue;
					} else {
						form.append("delete", 1);
					}
					continue;
				} else if (key === "questionTags") {
					form.append(key, JSON.stringify(questiontags));
				} else if (key === "addToDatabank") {
					form.append("addToDatabank", true);
				} else {
					form.append(key, this.questions[key]);
				}
			}

			form.append("sectionID", this.selectedSection.sectionID);
			form.append("testID", this.selectedSection.testID);

			return form;
		},

		async postFormDatamcq(form) {
			return await postCommonQuestionv2(form);
		},

		async addautomcqquestion() {
			try {
				if (this.questions.file) {
					this.showVideoUploading = true;
				}
				this.showSpinner = true;
				this.validateQuestion();

				if (!this.$v.$invalid && !this.dirtyLongQuestion) {
					let bucketPath = null;

					if (this.questions.file && this.questions.fileMeta) {
						bucketPath = await this.uploadFileViaSocket(
							this.questions.file,
							this.questions.fileMeta
						);
					}
					const form = this.buildFormData(bucketPath);
					form.append("sectionID", this.autosectionID);
					form.append("testID", this.$route.params.testID);
					form.append("type", "ADD_QUES");
					form.append("topicID", this.topicID);
					form.append("selected", "A");
					form.append("delete", "1");

					const response = await this.postFormData(form);

					if (response.status == 200) {
						this.handleSuccess(response);
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					} else {
						this.handleError();
					}
				} else {
					this.errorToast("Please enter all the details");
				}
			} catch (error) {
				this.handleError();
				throw new Error(`Failed! status:${error.status}`);
			} finally {
				// clearing card data
				this.clearData();
			}
		},

		validateQuestion() {
			if (this.questions.question === "") {
				this.dirtyLongQuestion = true;
			}

			this.questions.questionTags = this.questions.questionTags.map((s) =>
				s[0] == "#" ? s.slice(1) : s
			);

			this.$v.$touch();
		},

		buildFormData(bucketPath) {
			const questiontags = JSON.stringify(this.questions.questionTags);
			const form = new FormData();

			for (const key in this.questions) {
				if (key === "questionMedia") {
					this.handleQuestionMedia(form, bucketPath);
				} else {
					form.append(
						key,
						key === "questionTags" ? questiontags : this.questions[key]
					);
				}
			}

			return form;
		},

		handleQuestionMedia(form, bucketPath) {
			// Case 1: no media at all
			if (!this.questions.file && !this.questions.questionMedia) {
				form.set("delete", 1);
				return;
			}

			// Case 2: media exists but unchanged
			if (!this.questions.file && this.questions.questionMedia) {
				return;
			}

			// Case 3: new media via socket
			if (bucketPath) {
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.questions.questionMediaType);
			}
		},
		async postFormData(form) {
			try {
				return await postCommonQuestionv2(form);
			} catch (error) {
				console.log(error);
			}
		},

		handleSuccess(response) {
			this.successToast("Question added successfully!");
			this.questions.questionKey = response.data.data.QuestionID;
			this.$emit("question-added");
		},

		handleError() {
			this.errorToast("Something went wrong!");
		},

		removeMedia() {
			this.checkMedia = false;
			this.questions.questionMedia = "";
			this.questions.questionMediaType = "";
			this.questions.fileMeta = null;
		},
		clearData() {
			this.addques = true;
			this.$refs.questionTagref.reset();
			this.dirtyLongQuestion = false;

			this.$emit("clearData");
			this.showdatacard = false;
			this.$v.$reset();
			this.removeMedia();
		},
	},
};
</script>
<style scoped>
.v-toast {
	position: fixed;
	display: flex;
	top: -4px;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 0em 1em;
	overflow: hidden;
	z-index: 1052;
	pointer-events: none;
}
.card {
	border-radius: 12px;
	margin: 2%;
	box-shadow: 7px 10px 7px #c5c2c2;
	text-align: left;
}
.card-header {
	padding-top: 0.5rem;
	padding-bottom: -1rem;
	background-color: transparent;
}
.display-choice {
	display: flex;
	justify-content: space-between;
}
.display-choice p {
	padding: 7px 0;
	margin: 0;
	font-size: 20px;
	color: #707070;
	font-weight: 500;
}
.social-icon {
	padding: 0;
	margin: 0;
}
.textdesign {
	font-size: 14px;
	color: #808080;
}

.social-icon li {
	list-style: none;
	display: inline-block;
	padding: 0 4px;
	margin-right: -3px;
}
.marks-details {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-right: 10%;
}

.input {
	margin-bottom: 20px;
	border-bottom: 2px solid grey;
	border-left: none;
	border-right: none;
	border-top: none;
	border-radius: 0px;
	width: 95%;
}
.form-control:focus,
.custom-select:focus {
	border-color: inherit;
	-webkit-box-shadow: none;
	box-shadow: none;
}
.switch {
	margin-top: 2vh;
	margin-right: 2vh;
}

/* FILE UPLOAD CSS */
* {
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-webkit-box-sizing: border-box;
}

body {
	font-family: "Montserrat", sans-serif;
	background: #535c68;
}

.wrapper {
	margin: auto;
	max-width: 640px;
	padding-top: 60px;
	text-align: center;
}

.container {
	background-color: #f9f9f9;
	padding: 20px;
	border-radius: 10px;
	text-align: center;
}
.audio-preview {
	width: 500px;
	height: 245px;
	object-fit: contain;
	background-color: white;
	border: 1px solid #ddd;
	padding: 5px;
	display: flex;
	flex-wrap: wrap;
	align-content: center;
}
.preview {
	width: 500px;
	height: 500px !important;
	background-color: white;
	border: 1px solid #ddd;
	padding: 5px;
	display: flex;
	flex-wrap: wrap;
	align-content: center;
}
h1 {
	color: #130f40;
	font-family: "Varela Round", sans-serif;
	letter-spacing: -0.5px;
	font-weight: 700;
	padding-bottom: 10px;
}

.upload-container {
	background-color: rgb(239, 239, 239);
	border-radius: 6px;
	padding: 10px;
}

.border-container {
	border: 5px dashed rgba(198, 198, 198, 0.65);
	border-radius: 6px;
	padding: 20px;
}

.border-container p {
	color: #130f40;
	font-weight: 600;
	font-size: 1.1em;
	letter-spacing: -1px;
	margin-top: 30px;
	margin-bottom: 0;
	opacity: 0.65;
}

#file-browser {
	text-decoration: none;
	color: rgb(22, 42, 255);
	border-bottom: 3px dotted rgba(22, 22, 255, 0.85);
}

#file-browser:hover {
	color: rgb(0, 0, 255);
	border-bottom: 3px dotted rgba(0, 0, 255, 0.85);
}

.icons {
	color: #95afc0;
	opacity: 0.55;
}

.rounded-circle {
	border-color: transparent;
	background-color: #f2f2f2;
}
.question-entry {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.question-content {
	width: 93%;
}
.inputQuestion {
	width: 100%;
	margin-top: 1vh;
	background-color: #e0e0e0;
	border: none;
	font-size: 14px;
	color: #808080;
	font-weight: 400;
}
.inputQuestion:focus {
	width: 100%;
	margin-top: 1vh;
	background-color: #e0e0e0;
	border: none;
	font-size: 14px;
	color: #707070;
	font-weight: 400;
}
.ques-img {
	margin-top: 6px;
	margin-left: 2px;
}

.required-buttons {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.required-buttons .switch {
	margin-left: 8px;
	margin-right: 4px;
}

.header-btns:hover {
	background-color: #f5f5f5;
	color: #6c757d;
	border-color: #f5f5f5;
}

.header-btns:not(:disabled):not(.disabled):active,
.header-btns:not(:disabled):not(.disabled).active,
.show > .header-btns.dropdown-toggle {
	background-color: #f5f5f5;
	color: #6c757d;
	border-color: #f5f5f5;
	box-shadow: 0 0 0 0 !important;
}
.btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: 0 0 0 0rem;
}

.fas {
	color: #6c757d !important ;
}
.custom-select:focus {
	border-bottom: 2px solid #707070 !important;
	box-shadow: none;
}

.delete-icon {
	position: absolute;
	right: 92px;
	cursor: pointer;
}
.audio-class {
	width: 30vw;
	height: 4vh;
	margin-bottom: 10px;
}
</style>
